import Layout from "../components/layout";
import Lightbox from "react-image-lightbox";
import {useParams} from "react-router";
import {useEffect} from "react";

const idRegex = /^[0-9]{1,32}$/

function MenuView() {
    let {id} = useParams();

    useEffect(() => {
        if (!idRegex.test(id)) {
            window.close()
        }
    }, [])

    return (
        <Layout>
            <Lightbox
                mainSrc={"/karten/" + id + ".jpg?v=" + Date.now()}
                onCloseRequest={() => window.close()}
            />
        </Layout>
    )
}

export default MenuView